import { __rest } from 'tslib';
import React from 'react';
import { PeekDrawer } from './PeekDrawer.js';
import { styled } from '@mui/material/styles';

const PeekMiniDrawer = styled((_a) => {
    var props = __rest(_a, []);
    return React.createElement(PeekDrawer, Object.assign({}, props));
}, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, drawerWidth, miniDrawerWidth, bgColor }) => {
    const backgroundColor = 
    //@ts-ignore
    (bgColor && ((theme.palette[bgColor] && theme.palette[bgColor].main) || bgColor)) || theme.palette.primary.main;
    return {
        width: (open && drawerWidth) || miniDrawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        overflowX: "hidden",
        "& .MuiDrawer-paper": {
            backgroundColor,
            width: (open && drawerWidth) || miniDrawerWidth,
            boxSizing: "border-box",
            overflowX: "hidden",
            "-webkit-transition": "width .2s ease-in-out",
            "-moz-transition": "width .2s ease-in-out",
            "-o-transition": "width .2s ease-in-out",
            transition: "width .2s ease-in-out",
        },
    };
});

export { PeekMiniDrawer, PeekMiniDrawer as default };
